import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { removeEquipment } from "../../../api/group";
import EditIconTable from "../../../assets/SVG/editIconTable";
import SelectionsTableDrug from "../drug/selectionsTableDrug";

export default function TableEquipment({
  rowData,
  setRowData,
  gridRef,
  create,
  date,
  date1,
  tableArea,
  notGroup,
  setEquipmentIdFromUpdate,
  setMode,
  
}) {
  const [selection, setSelection] = useState([]);
  const onSelectionChanged = (e) => {
    const selectedNodes = e.api.getSelectedNodes();
    const lastSelectedNode =
      selectedNodes[0]?.selectionController?.lastSelectedNode;
    // if lastSelectedNode is missing while multi-selecting,
    // AgGrid will select from the first row
    const selectedNodeFrom = lastSelectedNode || e.api.getRenderedNodes()[0];
    const isRangeSelect = KEYBOARD_STATE.isShiftPressed;
    const difference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x));
    const newSelection = difference(selectedNodes, selection);

    if (newSelection.length > 0) {
      if (isRangeSelect) {
        const isSelectBackward =
          newSelection[0].rowIndex < selectedNodeFrom.rowIndex;

        if (isSelectBackward) {
          newSelection.reverse();
        }
      }

      newSelection.forEach((n) => updateSelection(n));
    } else {
      updateSelection(); // deselect
    }
  };
  const KEYBOARD_STATE = {
    isShiftPressed: false,
  };
  document.addEventListener("keydown", (e) => {
    KEYBOARD_STATE.isShiftPressed = e.key === "Shift";
  });
  document.addEventListener("keyup", (e) => {
    KEYBOARD_STATE.isShiftPressed = false;
  });
  const updateSelection = (rowNode) => {
    setSelection((selections) => {
      if (rowNode) {
        const isSelected = rowNode.isSelected();

        if (isSelected) {
          return [...selections, rowNode];
        } else {
          return selections.filter((s) => s.id !== rowNode.id);
        }
      } else {
        return selections.filter((n) => n.isSelected());
      }
    });
  };
  // console.log(rowData);
  const [colDefs] = useState([
    {
      headerName: "ردیف",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },

    {
      field: "name",
      headerName: "اسم تجهیزات",
      width: 200,
    },
    {
      field: "equipmentType",
      headerName: "نوع تجهیز",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.equipmentType === "INFRASTRUCTURE"
                ? "زیرساختی"
                : "مصرفی"}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "healthStatus",
      headerName: "وضعیت",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.healthStatus === "VALID"
                ? "سالم"
                : x.data?.healthStatus === "DAMAGED"
                ? "خراب"
                : "در حال تعمیر"}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "expireAt",
      headerName: "تاریخ خرید",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            {create ? (
              <Typography fontFamily="Shabnam">
                {`${date?.day} / ${date?.month} / ${date?.year} `}
              </Typography>
            ) : (
              <Typography fontFamily="Shabnam">
                {x.data?.buyAt?.split("T", 2)[0]}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "expireAt",
      headerName: "تاریخ مصرف",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            {create ? (
              <Typography fontFamily="Shabnam">
                {`${date1?.day} / ${date1?.month} / ${date1?.year} `}
              </Typography>
            ) : (
              <Typography fontFamily="Shabnam">
                {x.data?.usedAt?.split("T", 2)[0]}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "producer",
      headerName: "شرکت سازنده",
      width: 200,
    },
    {
      field: "available",
      headerName: "تعداد ",
      width: 200,
    },

    // {
    //   field: "",
    //   headerName: "قیمت کل",
    //   width: 200,
    // },
    {
      field: "location",
      headerName: "محل انبار",
      width: 200,
    },
    {
      field: "rowNo",
      headerName: "شماره ردیف",
      width: 200,
    },
    {
      field: "shelfNo",
      headerName: "شماره قفسه",
      width: 200,
    },
    {
      field: "description",
      headerName: "توضیحات",
      width: 200,
    },
    {
      field: "name",
      headerName: "عملیات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" gap="10px" alignItems="center">
            <Box
              width={"50px"}
              textAlign="center"
              bgcolor="var(--emr-red)"
              px="10px"
              borderRadius={"15px"}
              color="white"
              fontFamily="Shabnam"
              onClick={() => {
                removeEquipment(x.data?.id)
                  .then(() => {
                    setRowData((z) => {
                      let array = [...z];
                      array = array.filter((item) => item.id !== x.data.id);
                      return array;
                    });
                  })
                  .catch(() => {});
              }}
            >
              حذف
            </Box>
            <Box
              width={"80px"}
              height="40px"
              textAlign="center"
              bgcolor="var(--emr-blue)"
              px="10px"
              borderRadius={"15px"}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              sx={{ cursor: "pointer" }}
              onClick={() => {
                // setOpenEditModal(true);
                // setDataRowEdit(x.data);
                setEquipmentIdFromUpdate(x.data);
                setMode("new");
              }}
            >
              <Typography color="white" fontFamily="Shabnam">
                {"ویرایش"}
              </Typography>
              <EditIconTable color="white" />
            </Box>
          </Box>
        );
      },
    },
  ]);
  const [colDefs1] = useState([
    {
      headerName: "ردیف",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },

    {
      field: "name",
      headerName: "اسم تجهیزات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.equipmentInfo?.name}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "healthStatus",
      headerName: "وضعیت",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.equipmentInfo?.healthStatus === "VALID"
                ? "سالم"
                : x.data?.equipmentInfo?.healthStatus === "DAMAGED"
                ? "خراب"
                : "در حال تعمیر"}
            </Typography>
          </Box>
        );
      },
    },

    {
      field: "name",
      headerName: "شرکت سازنده",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.equipmentInfo?.producer}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "expireAt",
      headerName: "اعتبار گارانتی",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            {create ? (
              <Typography fontFamily="Shabnam">
                {`${date1?.day} / ${date1?.month} / ${date1?.year} `}
              </Typography>
            ) : (
              <Typography fontFamily="Shabnam">
                {x.data?.equipmentInfo?.guaranteeExpireAt?.split("T", 2)[0]}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "name",
      headerName: "توضیحات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <Typography fontFamily="Shabnam">
              {x.data?.equipmentInfo?.description}
            </Typography>
          </Box>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: false,
  }));

  return (
    <>
      <div
        className="ag-theme-quartz"
        style={{ height: create ? 120 : "55vh", marginTop: 10 }}
      >
        <AgGridReact
          // pagination={true}
          rowHeight={60}
          enableRtl={true}
          rowData={rowData}
          ref={gridRef}
          columnDefs={tableArea ? colDefs1 : colDefs}
          defaultColDef={defaultColDef}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
          onSelectionChanged={onSelectionChanged}
          onCellValueChanged={(event) =>
            console.log(`New Cell Value: ${event.value}`)
          }
        />
      </div>
      {selection?.length > 0 && (
        <SelectionsTableDrug
          notGroup={notGroup}
          equipment
          selection={selection}
        />
      )}
    </>
  );
}
